
import { Interview } from "@/types/interview";
import { PendingInterviewsService } from "./fetch/pendingInterviewsService";
import { FeederInterviewsService } from "./fetch/feederInterviewsService";
import { PublishedInterviewsService } from "./fetch/publishedInterviewsService";
import { InterviewMapperService } from "./base/interviewMapperService";

/**
 * Facade service for fetching interview data
 */
export class InterviewFetchService {
  /**
   * Fetch all pending interviews
   */
  static async getPendingInterviews(): Promise<Interview[]> {
    return PendingInterviewsService.getPendingInterviews();
  }

  /**
   * Get a single interview by ID
   */
  static async getInterviewById(interviewId: string): Promise<Interview | null> {
    return PendingInterviewsService.getInterviewById(interviewId);
  }

  /**
   * Fetch all interviews marked for the feeder queue
   */
  static async getFeederInterviews(): Promise<Interview[]> {
    return FeederInterviewsService.getFeederInterviews();
  }

  /**
   * Fetch all published interviews
   */
  static async getPublishedInterviews(): Promise<Interview[]> {
    return PublishedInterviewsService.getPublishedInterviews();
  }

  /**
   * Mark an interview as part of the feeder queue
   */
  static async markForFeeder(interviewId: string): Promise<boolean> {
    return FeederInterviewsService.markForFeeder(interviewId);
  }

  /**
   * Maps a database interview record to the Interview model
   * @private
   */
  private static mapDatabaseInterviewToModel(data: any): Interview {
    return InterviewMapperService.mapDatabaseInterviewToModel(data);
  }

  /**
   * Validate summary status to ensure it matches the expected type
   */
  static validateSummaryStatus(status: string | null): Interview['summary_status'] {
    return InterviewMapperService.validateSummaryStatus(status);
  }

  /**
   * Validate publication status to ensure it matches the expected type
   */
  static validatePublicationStatus(status: string | null): Interview['publication_status'] {
    return InterviewMapperService.validatePublicationStatus(status);
  }
}
